import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useInvoiceContext, useControlContext } from "../context";
import { capitalizeFirstLetter } from "../utils";
import styled, { keyframes } from 'styled-components';

const ProgressViewer = () => {
  const { progressViewerCustomer, progressViewerEmail, progressViewerPayment } = useControlContext();
  const { 
    customer,
    paymentMethod,
    cart,
    updateItemTermById
  } = useInvoiceContext();

  const AcceptTerm = styled.div`
    background-color: #f8f2ca;
    padding: 10px;
    margin-top: 10px;
    border-radius: 5px;
  `;

  return (
    <div>

      {/* faz loop em cart e exibe os produtos */}
      {cart.map((product, index) => (
        product.tem_termo === 'S' && (
          <AcceptTerm key={index}>
              <input
                type="checkbox"
                id={`termo-${index}`}
                onChange={(e) => updateItemTermById(product.id, e.target.checked)}
                checked={product.termo_aceito === '1'}
              />{' '}
              <span>Eu li e aceito os <a href={product.termo_link} target="_blank" rel="noreferrer">
                Termos de Uso
              </a>
              {' '}
              do serviço
              {' '}
              <strong>
                {product.name}
              </strong>.
              </span>
          </AcceptTerm>
        )
      ))}

      <p
        className="text-muted"
        style={{ fontSize: "0.8em", marginTop: "0.5em", marginBottom: "0.1em" }}
      >
        Conclua as etapas anteriores para continuar
      </p>
      <small>
        <FontAwesomeIcon
          icon={progressViewerCustomer ? faCheck : faXmark}
          style={{ color: progressViewerCustomer ? "#5cb85c" : "#d9534f" }}
        />
        {"  "}Cliente: {customer.xnome && progressViewerCustomer ? customer.xnome : "não informado"}
      </small>
      <br />
      <small>
        <FontAwesomeIcon
          icon={progressViewerEmail ? faCheck : faXmark}
          style={{ color: progressViewerEmail ? "#5cb85c" : "#d9534f" }}
        />
        {"  "}E-mail de entrega: {customer.email && progressViewerEmail ? customer.email : "não informado"}
      </small>
      <br />
      <small>
        <FontAwesomeIcon
          icon={progressViewerPayment ? faCheck : faXmark}
          style={{ color: progressViewerPayment ? "#5cb85c" : "#d9534f" }}
        />
        {"  "}Forma de pagamento: {paymentMethod && progressViewerPayment ? capitalizeFirstLetter(paymentMethod) : "não informado"}
      </small>
    </div>
  );
};

export default ProgressViewer;
